import Carousel from 'react-material-ui-carousel';
import React from 'react';
import { SlideshowData } from '../../../Content';

interface SlideshowContentProps {
  content: SlideshowData;
}

export const SlideshowContent: React.FC<SlideshowContentProps> = ({
  content,
}) => {
  return (
    <Carousel
      animation="slide"
      interval={6000}
      autoPlay={true}
      navButtonsProps={{
        className: 'carousel-nav-button',
        style: { color: 'white' },
      }}
    >
      {content.images.map(({ src, aspect }) => (
        <div
          key={src}
          style={{
            width: '100%',
            paddingBottom: `${(aspect ?? content.aspect ?? 1) * 100}%`,
            backgroundImage: `url("${src}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        ></div>
      ))}
    </Carousel>
  );
};
